import React, { Component } from 'react';
import Select from 'react-select';
import './DropdownSearch.css';

const bigList = [];
bigList.push({ value: "alpha", label: "Alphabetical" });
bigList.push({ value: "reverse-alpha", label: "Reverse Alphabetical" });
bigList.push({ value: "numPlayersAsc", label: "Number of Players Ascending" });
bigList.push({ value: "numPlayersDesc", label: "Number of Players Descending" });

const sortOptions = {
  'alpha': 'Alphabetical',
  'reverse-alpha': "Reverse Alphabetical",
  'numPlayersAsc': "Number of Players Ascending",
  'numPlayersDesc': "Number of Players Descending"
}

class SortMenu extends Component {
    constructor(props) {
        super(props);
        this.state = {
            sort: "alpha",
        };

        this.selectOption = this.selectOption.bind(this);
    }

    selectOption(e) {
        this.setState({ sort: e });
        this.onSortChange(e);
    }

    onSortChange(e) {
        this.props.onSortOrderChange(e.value);
    }

    render() {


      var displayTitle = sortOptions[this.props.displaySort];
      
        return (
            <div className="box">
              <div className="col">
                <p>Sort</p>
              </div>
              <Select
                options={bigList}
                onChange={this.selectOption}
                defaultValue = {{ label: displayTitle, value: this.props.displayPlayerFilter }} />
            </div>
          );
    }
}

export default SortMenu;